import { useAuth, useRequest } from "@onefront/react-sdk";
import { buildHeaders } from "../../../views/common-utils/buildHeaders";
import { useCallback, useState } from "react";

export function useDeleteDocuments(): {
  deleteDocuments: (workspaceId: string, payload: string[]) => Promise<boolean>;
  error: any;
  loading: boolean;
} {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const authData = useAuth();
  const request = useRequest();

  const deleteDocuments = useCallback(
    async (workspaceId: string, payload: string[]) => {
      setLoading(true);

      try {
        await request.fetch({
          headers: buildHeaders({ authData }),
          data: {
            documentsId: payload,
          },
          method: "DELETE",
          lazy: true,
          stateless: true,
          url: `documentsApi://api/v1/documents/deleteMultiple?workspaceId=${workspaceId}`,
        });
        return true;
      } catch (err: any) {
        console.error(err);
        setError(err);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [authData, request]
  );

  return {
    deleteDocuments,
    error: error,
    loading,
  };
}
